import './_styles.scss';
import React from "react";
import { Item, Sorting } from 'components';
import Pattern from 'assets/memphis_pattern.svg';

export default ({ data = [], active_category, change_sorting }) => {

  const current_index = data.length===0 ? 0 : 1;

  return (<div className='Section-Catalog-Body'>

    <div className="Header">

      <div>
        <div className="Title">{active_category.caption}</div>
        <div className="Caption">Showing {current_index} - {data.length} of {data.length} products</div>
      </div>

      <Sorting onChange={change_sorting}/>

      <div className="Pattern" style={{ backgroundImage: `url(${Pattern})` }} />

    </div>

    <div className="Product-Grid">
      {data.map((a, i) => <Item
        key={i}
        id={a.handle}
        title={a.title}
        category={a.category}
        price={a.pricing.price}
        image={a.images[1]}
        loading={false}
        rating={{}}
      />
      )}
    </div>

  </div>
  );
}
